(() => {
  'use strict';
  const root = document.querySelector('[data-international-product]');
  if (!root) return;
  const state = JSON.parse(root.querySelector('[data-ip-state]').textContent);
  const form = root.querySelector('.ip-form');
  const status = root.querySelector('.ip-status');
  const buttons = [...form.querySelectorAll('button[type="submit"]')];
  const main = root.querySelector('.ip-main-image img');
  const initialImage = main ? {url: main.currentSrc || main.src, alt: main.alt} : null;
  const variant = () => state.variants.find(v => String(v.id) === form.elements.id.value);
  let pending = false;
  const sync = (updateImage = false) => {
    const selected = variant();
    buttons.forEach(b => b.disabled = pending || !selected?.available || root.dataset.purchaseEnabled !== 'true');
    if (!selected) return;
    root.querySelector('[data-ip-price]').textContent = selected.formatted;
    root.querySelector('[data-ip-compare]').textContent = selected.formattedComparison;
    root.querySelector('[data-ip-comparison]').hidden = selected.comparison <= selected.price;
    if (updateImage && main) {
      main.removeAttribute('srcset');
      main.src = selected.image || initialImage.url;
      main.alt = selected.imageAlt || initialImage.alt;
    }
  };
  form.elements.id.addEventListener('change', () => sync(true));
  sync();
  const dialog = root.querySelector('.ip-zoom');
  root.querySelectorAll('[data-ip-photo]').forEach(button => button.addEventListener('click', () => {
    main.removeAttribute('srcset');
    main.src = button.dataset.ipPhoto;
    main.alt = button.dataset.ipAlt;
    root.querySelectorAll('[data-ip-photo]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
  }));
  root.querySelector('[data-ip-zoom]')?.addEventListener('click', () => {
    const image = dialog.querySelector('img');
    image.removeAttribute('srcset');
    image.src = main.currentSrc || main.src;
    image.alt = main.alt;
    dialog.showModal();
  });
  root.querySelector('[data-ip-close]')?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (pending) return;
    const selected = variant(), quantity = Number(form.elements.quantity.value);
    status.textContent = '';
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 10) { status.textContent = state.messages.quantity_error; return; }
    if (!selected?.available || root.dataset.purchaseEnabled !== 'true' || !/^\d+$/.test(String(selected.id))) { status.textContent = state.messages.error; return; }
    pending = true;
    sync();
    form.setAttribute('aria-busy', 'true');
    try {
      if (!event.submitter || event.submitter.dataset.ipAction === 'buy') {
        if (typeof window.Rediretyc?.checkout !== 'function') throw Error(state.messages.error);
        // The integration calls its key sku; its value is always the native variant ID.
        await window.Rediretyc.checkout([{sku: String(selected.id), qty: quantity, price: selected.price / 100, title: state.title}], {currency: state.currency});
      } else {
        const base = window.Shopify?.routes?.root || '/';
        const response = await fetch(base + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [{id: selected.id, quantity}]})});
        if (!response.ok) throw Error(state.messages.error);
        window.location.assign(root.dataset.cartUrl);
      }
    } catch (error) {
      status.textContent = error instanceof TypeError ? state.messages.network : state.messages.error;
    } finally {
      pending = false;
      sync();
      form.removeAttribute('aria-busy');
    }
  });
})();

(() => {
  'use strict';
  const root = document.querySelector('[data-international-cart]');
  if (!root) return;
  const form = root.querySelector('form');
  if (!form) return;
  const state = JSON.parse(root.querySelector('[data-ip-cart-state]').textContent);
  const status = root.querySelector('.ip-cart-status');
  root.querySelectorAll('[data-ip-remove]').forEach(button => button.addEventListener('click', () => {
    button.closest('.cart-item').querySelector('input[name="updates[]"]').value = '0';
    form.requestSubmit();
  }));
  let pending = false;
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (pending) return;
    const quantities = [...form.querySelectorAll('input[name="updates[]"]')].map(i => Number(i.value));
    if (quantities.some(q => !Number.isInteger(q) || q < 0 || q > 1000)) { status.textContent = state.error; return; }
    pending = true;
    status.textContent = '';
    const buttons = [...form.querySelectorAll('button')];
    buttons.forEach(b => b.disabled = true);
    form.setAttribute('aria-busy', 'true');
    try {
      const base = window.Shopify?.routes?.root || '/';
      const response = await fetch(base + 'cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({updates: quantities})});
      if (!response.ok) throw Error(state.error);
      const cart = await response.json();
      if (event.submitter?.dataset.ipCartCheckout !== undefined && cart.items.length) {
        if (typeof window.Rediretyc?.checkout !== 'function') throw Error(state.error);
        const items = cart.items.map(item => ({sku: String(item.variant_id), qty: item.quantity, price: item.final_price / 100, title: item.product_title}));
        if (items.some(item => !/^\d+$/.test(item.sku))) throw Error(state.error);
        await window.Rediretyc.checkout(items, {currency: cart.currency});
      } else window.location.reload();
    } catch (_) { status.textContent = state.error; }
    finally { pending = false; buttons.forEach(b => b.disabled = false); form.removeAttribute('aria-busy'); }
  });
})();
